import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveProjectBudgetSynthesis from "./retrieveProjectBudgetSynthesis";
import * as createCostProfile from "./createCostProfile";
import * as retrieveCostProfiles from "./retrieveCostProfiles";
import * as editCostProfile from "./editCostProfile";
import * as removeCostProfile from "./removeCostProfile";
import * as assignCostProfileToResource from "./assignCostProfileToResource";
import * as removeCostProfileFromResource from "./removeCostProfileFromResource";
import * as retrieveCostProfileCostsHistory from "./retrieveCostProfileCostsHistory";
import * as removeCost from "./removeCost";
import * as editCost from "./editCost";
import * as editProjectAllocatedBudget from "./editProjectAllocatedBudget";
import * as retrieveProjectExpenses from "./retrieveProjectExpenses";
import * as createProjectExpense from "./createProjectExpense";
import * as retrieveProjectExpenseTypes from "./retrieveProjectExpenseTypes";
import * as createProjectExpenseType from "./createProjectExpenseType";
import * as removeProjectExpense from "./removeProjectExpense";
import * as editProjectExpense from "./editProjectExpense";
import * as editProjectAllocatedResourcesBudget from "./editProjectAllocatedResourcesBudget";
import * as editProjectAllocatedExpensesBudget from "./editProjectAllocatedExpensesBudget";

const initialState: State = {
  retrieveProjectBudgetSynthesis: retrieveProjectBudgetSynthesis.initialState,
  createCostProfile: createCostProfile.initialState,
  retrieveCostProfiles: retrieveCostProfiles.initialState,
  editCostProfile: editCostProfile.initialState,
  removeCostProfile: removeCostProfile.initialState,
  assignCostProfileToResource: assignCostProfileToResource.initialState,
  removeCostProfileFromResource: removeCostProfileFromResource.initialState,
  retrieveCostProfileCostsHistory: retrieveCostProfileCostsHistory.initialState,
  removeCost: removeCost.initialState,
  editCost: editCost.initialState,
  editProjectAllocatedBudget: editProjectAllocatedBudget.initialState,
  retrieveProjectExpenses: retrieveProjectExpenses.initialState,
  createProjectExpense: createProjectExpense.initialState,
  retrieveProjectExpenseTypes: retrieveProjectExpenseTypes.initialState,
  createProjectExpenseType: createProjectExpenseType.initialState,
  removeProjectExpense: removeProjectExpense.initialState,
  editProjectExpense: editProjectExpense.initialState,
  editProjectAllocatedResourcesBudget:
    editProjectAllocatedResourcesBudget.initialState,
  editProjectAllocatedExpensesBudget:
    editProjectAllocatedExpensesBudget.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveProjectBudgetSynthesis: retrieveProjectBudgetSynthesis.reduceState,
  createCostProfile: createCostProfile.reduceState,
  retrieveCostProfiles: retrieveCostProfiles.reduceState,
  editCostProfile: editCostProfile.reduceState,
  removeCostProfile: removeCostProfile.reduceState,
  assignCostProfileToResource: assignCostProfileToResource.reduceState,
  removeCostProfileFromResource: removeCostProfileFromResource.reduceState,
  retrieveCostProfileCostsHistory: retrieveCostProfileCostsHistory.reduceState,
  removeCost: removeCost.reduceState,
  editCost: editCost.reduceState,
  editProjectAllocatedBudget: editProjectAllocatedBudget.reduceState,
  retrieveProjectExpenses: retrieveProjectExpenses.reduceState,
  createProjectExpense: createProjectExpense.reduceState,
  retrieveProjectExpenseTypes: retrieveProjectExpenseTypes.reduceState,
  createProjectExpenseType: createProjectExpenseType.reduceState,
  removeProjectExpense: removeProjectExpense.reduceState,
  editProjectExpense: editProjectExpense.reduceState,
  editProjectAllocatedResourcesBudget:
    editProjectAllocatedResourcesBudget.reduceState,
  editProjectAllocatedExpensesBudget:
    editProjectAllocatedExpensesBudget.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveProjectBudgetSynthesis.createSelector(
      () => getState().retrieveProjectBudgetSynthesis,
    ),
    ...createCostProfile.createSelector(() => getState().createCostProfile),
    ...retrieveCostProfiles.createSelector(
      () => getState().retrieveCostProfiles,
    ),
    ...editCostProfile.createSelector(() => getState().editCostProfile),
    ...removeCostProfile.createSelector(() => getState().removeCostProfile),
    ...assignCostProfileToResource.createSelector(
      () => getState().assignCostProfileToResource,
    ),
    ...removeCostProfileFromResource.createSelector(
      () => getState().removeCostProfileFromResource,
    ),
    ...retrieveCostProfileCostsHistory.createSelector(
      () => getState().retrieveCostProfileCostsHistory,
    ),
    ...removeCost.createSelector(() => getState().removeCost),
    ...editCost.createSelector(() => getState().editCost),
    ...editProjectAllocatedBudget.createSelector(
      () => getState().editProjectAllocatedBudget,
    ),
    ...retrieveProjectExpenses.createSelector(
      () => getState().retrieveProjectExpenses,
    ),
    ...createProjectExpense.createSelector(
      () => getState().createProjectExpense,
    ),
    ...retrieveProjectExpenseTypes.createSelector(
      () => getState().retrieveProjectExpenseTypes,
    ),
    ...createProjectExpenseType.createSelector(
      () => getState().createProjectExpenseType,
    ),
    ...removeProjectExpense.createSelector(
      () => getState().removeProjectExpense,
    ),
    ...editProjectExpense.createSelector(() => getState().editProjectExpense),
    ...editProjectAllocatedResourcesBudget.createSelector(
      () => getState().editProjectAllocatedResourcesBudget,
    ),
    ...editProjectAllocatedExpensesBudget.createSelector(
      () => getState().editProjectAllocatedExpensesBudget,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
